<template>
    <router-view />
</template>

<script setup>
// 在刷新页面后，新主题会失效
// 应用加载后，写入 `style` 即可
import { onMounted } from 'vue'
import { websocketCommand } from '@/utils/newWebsocket'
import { getItem } from '@/utils/storage'

onMounted(() => {
    // createWebChannel()
    let wsLink = window.location.host
    if (process.env.NODE_ENV === 'development') {
        // wsLink = '192.168.1.110'
        // wsLink = '192.168.1.86:8600'
        wsLink = '192.168.1.125'
    }
    if (getItem('userInfo')?.school) {
        // 创建连接
        websocketCommand({
            wsObj: new WebSocket('ws://' + wsLink + '/ws' + '?school=' + getItem('userInfo').school),
            type: 'create',
            wsName: 'navBar',
            msgCallback: () => {} // 本页面接收数据回调
        })
    }
})
</script>

<style lang="scss"></style>
